import { filterQuery as filter, sorter, _ } from '@feathersjs/commons'
import { dot, int, isNumeric, isPlainObject, stateList } from './'

const trimPercent = text => text.replace(/(^%|%$)/mg, '')

const operators = {
  $in: ins => current => ins.indexOf(current) !== -1,
  $nin: nins => current => nins.indexOf(current) === -1,
  $lt: value => current => current < value,
  $lte: value => current => current <= value,
  $gt: value => current => current > value,
  $gte: value => current => current >= value,
  $ne: value => current => current !== value,
  // $contains: (value, key) => current => value.includes(key),
  $like: value => current =>
    current.toLowerCase().includes(trimPercent(value).toLowerCase()),

  $gteDate: since => current => {
    if (current === null) return false
    return since <= current.getTime()
  },
}

const matcher = (originalQuery) => {
  const query = _.omit(originalQuery, '$limit', '$skip', '$sort', '$select')

  // TODO: pre-compile and cache query functions
  return function match(item) {
    if (query.$or && _.some(query.$or, or => matcher(or)(item))) return true

    return _.every(query, (value, key) => {
      if (key.includes('.')) {
        const dotValue = dot(item, key)

        if (typeof value === 'object') {
          return Object
            .keys(value)
            .every(operatorKey =>
              operators[operatorKey](value[operatorKey])(dotValue))
        } else {
          return query[key] === dotValue
        }
      } else if (value !== null && typeof value === 'object') {
        return _.every(value, (target, operatorKey) => {
          if (operators[operatorKey]) {
            // const filterer = operators[operatorKey](target[key], key)
            return operators[operatorKey](target)(item[key])
          }

          return false
        })
      } else if (typeof item[key] !== 'undefined') {
        return query[key] === item[key]
      }

      return false
    })
  }
}

// const queryTimers = []
// const setTimer = (store, params) => {
//   const result = {
//     count: Object.keys(store).length,
//     params,
//     timers: [],
//   }

//   queryTimers.push(result)

//   return (name, fn) => {
//     const start = Date.now()
//     fn()
//     const end = Date.now()
//     result.timers.push({
//       name,
//       start,
//       end,
//       duration: end - start,
//     })
//   }
// }

const Query = {
  _find(store, params, getFilter = filter) {
    if (isNumeric(params)) return store[int(params)]

    const { query, filters } = getFilter(params.query || {})
    // const timer = setTimer(store, params)

    let values

    const storeValues = _.values(store)
    const matcherFilter = matcher(query)
    if (query.$limit === 1) {
      values = [storeValues.find(matcherFilter)]
    } else {
      values = storeValues.filter(matcherFilter)
    }

    if (filters.$sort) {
      values.sort(typeof filters.$sort === 'function' ? filters.$sort : sorter(filters.$sort))
    }

    if (filters.$skip) {
      values = values.slice(filters.$skip)
    }

    if (typeof filters.$limit !== 'undefined') {
      values = values.slice(0, filters.$limit)
    }

    if (filters.$select) {
      values = values.map(value => _.pick(value, ...filters.$select))
    }

    return values
  },

  find(store, params) {
    if (!params) {
      params = {}
    }

    if (isPlainObject(params) && !params.query) {
      params = {
        query: params,
      }
    }

    // Call the internal find with query parameter that include pagination
    return this._find(store, params, query => filter(query))
  },
}

// setTimeout(() => {
//   console.log('queryTimers', queryTimers
//     .map(queryRecord => ({
//       ...queryRecord,
//       totalDuration: queryRecord
//         .timers
//         .reduce((sum, timer) => sum + timer.duration, 0)
//     }))
//     .sort(({ totalDuration: a }, { totalDuration: b }) => {
//       if (a > b) return -1
//       if (a < b) return 1
//       return 0
//     }))
// }, 3000)

export default state => (params, singleOut) => {
  const result = Query.find(stateList(state), params)

  if (singleOut) {
    if (result.length) {
      return result[0]
    } else if (isPlainObject(result)) {
      return result
    }

    return null
  }

  return result
}



// WEBPACK FOOTER //
// ./src/views/utils/query.js